import { render } from "./IconSharing.vue?vue&type=template&id=6e46aa06"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSharing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e46aa06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e46aa06', __exports__)) {
    api.reload('6e46aa06', __exports__)
  }
  
  module.hot.accept("./IconSharing.vue?vue&type=template&id=6e46aa06", () => {
    api.rerender('6e46aa06', render)
  })

}


export default __exports__